<div
  [ngClass]="classes"
  test-id="infoBanner"
>
  <div class="info-banner__content">
    <ng-content></ng-content>
  </div>
</div>
